import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = ({ className }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const languages = [
    { id: 'en', name: 'English' },
    { id: 'it', name: 'Italiano' }
  ];

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);
  
  const handleLanguageChange = (languageId) => {
    i18n.changeLanguage(languageId);
    setIsOpen(false);
  };
  
  const selectedLang = languages.find(lang => lang.id === i18n.language) || languages[0];
  
  return (
    <div className={`language-selector relative ${className || ''}`} ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 text-white hover:text-secondary transition-colors py-1 px-2 rounded-md focus:outline-none focus:ring-1 focus:ring-secondary"
      >
        <span className="text-xs sm:text-sm font-medium">{selectedLang.name}</span>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className={`h-4 w-4 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`} 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute top-full right-0 mt-1 bg-dark-gray rounded-md shadow-lg overflow-hidden z-50 min-w-[120px]">
          {languages.map(lang => (
            <button
              key={lang.id}
              onClick={() => handleLanguageChange(lang.id)}
              className={`w-full text-left px-4 py-2 text-xs sm:text-sm hover:bg-background/30 transition-colors
                ${i18n.language === lang.id ? 'text-secondary font-medium' : 'text-white'}
              `}
            >
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
